import { SUCCESS } from "../../../../constants/action-postfix";
import { STUDENTS_INFO_REQUEST } from "../studentsInfoReducer";


const initialState = null;

export const modeReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${STUDENTS_INFO_REQUEST}${SUCCESS}`:
            return action.payload.mode;
        default:
            return state;
    }
};
